import { motion } from 'framer-motion'
import { downloadImageAutodetectingFilename } from '#app/utils/download.ts'
import { timeSince } from '#app/utils/time.ts'
import { ModalPortal } from './modal-portal.tsx'
import { Button } from './ui/button.tsx'
import { Icon } from './ui/icon.tsx'

export type ImageModalProps = {
	src: string
	createdAt?: Date
	onClose: () => void
}

export function ImageModal(props: ImageModalProps) {
	return (
		<ModalPortal>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.2 }}
			>
				<div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50 px-1">
					<div className="rounded-md border-[1px] border-solid border-[#1f1f1f] bg-[var(--darker-bg)] p-4 shadow-xl">
						<div className="flex flex-row items-center justify-between gap-1">
							<div className="text-xs">
								{props.createdAt && timeSince(new Date(props.createdAt))}
							</div>
							<div className="flex flex-row justify-between gap-1">
								<Button
									aria-label="Download Image"
									variant="outline"
									onClick={() => downloadImageAutodetectingFilename(props.src)}
								>
									<Icon name="download"> </Icon>
								</Button>
								<Button
									variant="outline"
									onClick={props.onClose}
									aria-label="Close image"
								>
									X
								</Button>
							</div>
						</div>
						<div className="h-2" />
						<img
							src={props.src}
							alt="enlarged generation"
							className="md:max-h-[85vh] w-auto md:min-h-[700px] md:max-w-[100vw]"
						/>
					</div>
				</div>
			</motion.div>
		</ModalPortal>
	)
}
